module.exports = __webpack_public_path__ + "static/img/关于我们banner.1c8356e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/关于我们/关于我们banner.png
// module id = nFbs
// module chunks = 0